import { EInputTextType , Input } from '../../components/Input/Input'
import { FormattedMessage , injectIntl, useIntl } from 'react-intl'
import { withRouter } from 'react-router';
import { RootState } from '../../reducers';
import { connect } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from '../../actions/generalActions';
import * as transportActions from '../../actions/transport';
import * as adminActions from '../../actions/admin';
import './admin.scss'
import { Button, EButtonType } from '../../components/Button';
import Tooltip from "rc-tooltip";
import clearFormSvg from "../../assets/icons/archeology.svg";
import TableBbros from "../../components/Table/TableBbros";
import {OPTIONS} from "../../components/Table/TableConstants";
import {Responsibility} from "../../types/responsibility.type";
import {toast} from "react-toastify";
import {t} from "../../i18n";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

interface Props {
    history:any;
    actions: any;
    production: any;
    intl: any;
    admin: any
    adminActions: any;
    transport: any;
    transportActions: any;
    loading: boolean;
    buttonLoader: boolean;
}

const Equipments = ( props: Props ) =>{
    const intl = useIntl();
    const fm = (id: string, defaultMessage: string) => intl.formatMessage({ id, defaultMessage });

    const [equipmentName , setEquipmentName] = useState<string>('')
    const [equipmentId, setEquipmentId] = useState<number>(null)

    const columns = useMemo(() => [
        { title: fm('admin.equipments.fieldName', 'Emri i pajisjes'), field: 'label', customSort: (a: any, b: any) => (a.label || '').length - (b.label || '').length }
    ], [intl]);

    const actions = [
        {
            icon: EditIcon,
            tooltip: fm('common.action.edit', 'Ndrysho'),
            onClick: (event: Event, rowData:Responsibility) => getEquipmentData(rowData)
        },
        {
            icon: DeleteIcon,
            tooltip: fm('common.action.delete', 'Fshi'),
            onClick: (event: Event, rowData:Responsibility) => deleteResponsibility(rowData)
        },
    ]

    useEffect(()=>{
        props.transportActions.fetchEquipments()
    }, [])

    function getEquipmentData (item) {
        setEquipmentName(item?.label)
        setEquipmentId(item?.value);
        toast.info(t('admin.equipments.toastSelected'))
    }

    function deleteResponsibility (item) {
        props.adminActions.deleteEquipment(item?.value).then((res)=>{
            if(res !== false){
                toast.info(t('admin.equipments.toastDeleted'))
                props.transportActions.fetchEquipments()
            }else{
                toast.error(t('admin.equipments.toastInUse'))
            }
        })
    }

    function saveEquipment(){
        if(equipmentName === ''){
            toast.error(t('admin.toastFillField'))
            return
        }
        let payload = {
            name: equipmentName
        }

        if(!equipmentId){
            props.adminActions.createEquipment(payload).then(()=>{
                props.transportActions.fetchEquipments()
                toast.info(t('admin.equipments.toastSaved'))
                resetFields()
            })
        }else{
            props.adminActions.editEquipment(payload, equipmentId).then(()=>{
                props.transportActions.fetchEquipments()
                toast.info(t('admin.equipments.toastUpdated'))
                resetFields()
            })
        }
    }

    function resetFields(){
        setEquipmentId(null)
        setEquipmentName('')
    }

    return(
        <div className="admin-page equipments-page">
            <div className="create-admin-page-form">
                <Input
                    name="responsibilityName"
                    value={equipmentName || ''}
                    type="text"
                    inputWrapperClass="col-12"
                    onChange={(name, value) => setEquipmentName(value)}
                    inputTextType={EInputTextType.SimpleInput}
                >
                    <FormattedMessage id="admin.equipments.fieldName" defaultMessage="Emri i pajisjes"/>
                </Input>
                <div>
                    <Button
                        isLoading={props?.buttonLoader}
                        isDisabled={props?.buttonLoader}
                        className="w-100"
                        buttonType={EButtonType.GreyButton}
                        onClick={saveEquipment}>
                        <FormattedMessage id="admin.equipments.btnSave" defaultMessage="Ruaj pajisjen"/>
                    </Button>
                </div>
            </div>
            <div className="admin-page-list">
                <h2 className="m-0 mb-4">
                    <FormattedMessage id="admin.equipments.listTitle" defaultMessage="Lista e pajisjeve"/>
                    <Tooltip placement="right" overlay={<span><FormattedMessage id="admin.clearForm" defaultMessage="Pastro formën"/></span>}>
                        <img className="create-client-icon" onClick={resetFields} src={clearFormSvg}
                             alt="create client"/>
                    </Tooltip>
                </h2>
                <TableBbros
                    title={fm('admin.equipments.tableTitle', 'Pajisjet')}
                    data={props.transport.equipments}
                    columns={columns}
                    options={OPTIONS}
                    actions={actions}
                    isLoading={props.loading}
                />
            </div>
        </div>
    )
}


function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        transport: state.transport,
        admin: state.admin
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
        transportActions: bindActionCreators(transportActions as any, dispatch),
        adminActions: bindActionCreators(adminActions as any, dispatch),
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(Equipments as any)));